export default __webpack_public_path__ + "static/media/uploader-oneTouchVerio-4.41fe1e93.png";